<template>
    <div class="page-wrapper image-to-colours-page">
        <div class="upload-area">
            <user-card v-if="$parent.documentData.name"></user-card>
            <router-link :to="{ name: 'Colour generator' }" class="close-icon">
                <img src="/assets/colour-generator/images/close.svg">
            </router-link>
            <div class="container">
                <form method="post" enctype="multipart/form-data">
                    <div class="upload-field">
                        <input type="file" name="file" ref="file" class="form-control-file"
                               v-on:change="handleFileUpload()">
                        <button type="button" class="btn btn-primary" :disabled="busy" v-cloak>
                            <div class="update-loader" style="padding: 6px;" v-if="busy">
                                <div class="loader-center">
                                    <span class="l-1"></span>
                                    <span class="l-2"></span>
                                    <span class="l-3"></span>
                                </div>
                            </div>
                           <span v-else >Upload Your Image</span>
                        </button>
                    </div>
                </form>
            </div>

            <div class="alert-error invalid-feedback" v-for="error in errors">
                {{ error[0] }}
            </div>

            <div class="updated-message-wrapper mt-2" v-if="successUpdateMessage">
                <div class="updated-message" style="display: block;">
                    <p><img src="/assets/img/checkbox-outline.svg" alt=""></p>
                </div>
            </div>

            <div class="uploaded-image" v-if="file">
                <div class="image"
                     v-bind:style="{ backgroundImage: 'url(' + file + ')' }">
                </div>
            </div>
        </div>

        <div class="details">
            <div class="container">

                <div class="row justify-content-center">
                    <div class="col-12 col-md-8">
                        <h2>Image to Colours</h2>
                        <p>The best way to get colours from your photos!</p>
                    </div>
                    <div class="col-12 col-md-8">
                        <div class="colors-palette">
                            <div class="colorbox" v-for="colour in colours">
                                <div class="color"
                                     @click="copyToClipboard('#' + colour.code)"
                                     v-bind:class="{ 'copied' : (copiedHex == '#'+colour.code) }"
                                     v-bind:style="{ backgroundColor: '#' + colour.code}"
                                     v-bind:data-clipboard-text="'#' + colour.code">
                                    <span class="copy-text">Copy</span>
                                    <span class="check-image">
                                    <img src="/assets/colour-generator/images/check.svg" class="check" alt="check">
                                </span>
                                </div>
                                <div class="hex-code">{{ '#' + colour['code'] }}</div>
                            </div>
                        </div>
                        <p class="mt-3">Colours amount: {{ sliderValue }}</p>
                        <range-slider
                            @change="updateColours(sliderValue)"
                            class="slider"
                            min="2"
                            v-bind:max="maxSliderValue"
                            step="1"
                            v-model="sliderValue">
                        </range-slider>

                        <p>&nbsp;</p>
                        <button @click="saveDocument()" v-if="!edit"
                                class="btn btn-outline-primary">SAVE THIS THEME
                        </button>

                        <button @click="updateDocument()" v-if="edit && !readOnly"
                                class="btn btn-outline-primary">{{ updateBtnText }}
                        </button>

                    </div>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
import RangeSlider from 'vue-range-slider';
import ApiService from "../../api/api.service";
import UserCard from "../partials/UserCard";

export default {
    name: "ColourImage",
    components: {
        RangeSlider,
        UserCard
    },
    data: function () {
        return {
            edit: false,
            readOnly: false,
            successMessage: "",
            errors: [],
            file: '/assets/colour-generator/images/image-placeholder.png',
            copiedHex: null,
            allColours: [],
            sliderValue: 0,
            maxSliderValue: 0,
            colours: [{"code":"c0d8ff","percentage":0.3371733333333333},{"code":"d89090","percentage":0.11882666666666666},{"code":"d87878","percentage":0.11093333333333333},{"code":"c06060","percentage":0.08128},{"code":"a83030","percentage":0.05637333333333333},{"code":"f0a8a8","percentage":0.05386666666666667},{"code":901818,"percentage":0.050506666666666665},{"code":"c04848","percentage":0.0472},{"code":"f0c0c0","percentage":0.031626666666666664},{"code":"90c0ff","percentage":0.025706666666666666},{"code":"ffa8a8","percentage":0.013066666666666667},{"code":"ffc0c0","percentage":0.012693333333333333},{"code":"ffffff","percentage":0.010186666666666667},{"code":"f0f0f0","percentage":0.0072},{"code":"c0d8f0","percentage":0.006346666666666666},{"code":"fffff0","percentage":0.005653333333333333},{"code":480000,"percentage":0.005546666666666667},{"code":"f0d8d8","percentage":0.00512},{"code":"f0ffff","percentage":0.005013333333333333},{"code":"d8c0d8","percentage":0.004746666666666666}],
            updateBtnText: 'UPDATE',
            successUpdateMessage: '',
            busy: false,
        }
    },
    mounted() {
        if (this.$route.query.id) {
            this.loadDocument();

        }


        this.init();

    },
    methods: {
        init() {
            this.sliderValue = Math.min(this.colours.length, 10);
            this.allColours = JSON.parse(JSON.stringify(this.colours)); // keep the clone
            this.maxSliderValue = this.allColours.length;
            // update on slider colour values on load
            if (this.sliderValue < this.colours.length) {
                this.updateColours(this.sliderValue);
            }

            let localData = localStorage.getItem('temp_app_data')
            if(localData) {
                localData = JSON.parse(localData);
                this.allColours = localData.entity_data.colours;
                this.sliderValue = localData.entity_data.coloursAmount;
                this.file = localData.entity_data.file;
                this.maxSliderValue = this.allColours.length;
                localStorage.removeItem('temp_app_data');
                // default colour
            }

            // clone
            if(this.$route.query.clone && this.document) {
                this.clone();
            }
        },

        loadDocument() {
            this.$parent.loadDoc(this.$route.query.id).then(({data}) => {
                this.document = data.doc;
                this.file = data.entity.meta.file;
                this.colours = data.entity.meta.colours;
                this.sliderValue = data.entity.meta.coloursAmount;

                this.init();
                this.edit = true;

                this.readOnly = !this.$parent.checkIfIamAuthor();
            });

        },

        saveDocument() {
            this.$parent.documentData.entity_data = {
                file: this.file,
                colours: this.colours,
                coloursAmount: this.sliderValue
            }
            this.$parent.saveDoc();
        },
        updateDocument() {
            this.updateBtnText = 'UPDATING...';
            this.$parent.documentData.entity_data = {
                file: this.file,
                colours: this.colours,
                coloursAmount: this.sliderValue
            }
            this.$parent.updateDoc(this.$route.query.id)
            setTimeout(() => {
                this.updateBtnText = 'UPDATE';
                this.successUpdateMessage = 'Document saved!';
                setTimeout(() => {
                    this.successUpdateMessage = '';
                }, 2000);
            }, 1000)
        },
        updateColours: function (newVal) {
            // let newVal = this.sliderValue;
            let startPosition = (newVal - this.allColours.length);
            let delCount = (this.allColours.length - newVal);
            let newSet = JSON.parse(JSON.stringify(this.allColours)); // clone
            newSet.splice(startPosition, delCount);

            this.colours = newSet;
        },

        handleFileUpload() {
            this.savingStatus = 'doing';
            this.busy = true;
            this.file = this.$refs.file.files[0];
            let formData = new FormData();
            formData.append('file', this.file);

                ApiService.postFile('/api/image-colours', formData)
                .then(({data}) => {
                    this.file = '/' + data.file;
                    this.colours = data.colours;
                    this.init();
                    this.errors = [];
                    setTimeout(() => {
                        this.savingStatus = '';
                        this.busy = false;
                    }, 600)
                }).catch(({response}) => {
                    this.file = '';
                    this.savingStatus = '';
                    this.errors = response.data.errors;
                    this.busy = false;
                });

        },


        clone() {
            this.$parent.settingCloneTitle = true;
            console.log(this.$parent.documentData);
            // console.log('cloning...')
        },

        // Copy to clipboard
        copyToClipboard: function (colourHex) {
            this.$copyText(colourHex).then((e) => {
                this.copiedHex = colourHex;

                // reset to normal after 2 seconds
                setTimeout(() => {
                    this.copiedHex = null;
                }, 2000)
            })
        }
    }
}
</script>

<style scoped>
.image-to-colours-page .details {
    margin-bottom: 0px;
}
</style>
